import React from "react";
import PageLayout from "../../components/PageLayout/PageLayout";
import StartSection from "./Sections/StartSection";
import CompetenceSection from "./Sections/CompetenceSection";
import ServiceSection from "./Sections/ServiceSection";
import PostSection from "./Sections/PostSection";
import ContactSection from "./Sections/ContactSection";
import { DEFAULT_TITLE, DEFAULT_DESCRIPTION } from "../../seo/siteSeo";

export default function HomePage(props) {
  const { configuration } = props;

  return (
    <PageLayout
      configuration={configuration}
      title="Sportplatzgarage Gutknecht"
      helmetTitle={DEFAULT_TITLE}
      description={DEFAULT_DESCRIPTION}
      path="/"
      includeLocalBusiness
      intro
      compact={false}
    >
      <StartSection
        openingHours={configuration.openingHours}
        homeWelcomeText={configuration.homeWelcomeText}
        homeWelcomeTitle={configuration.homeWelcomeTitle}
      />
      <CompetenceSection />
      <ServiceSection/>
      <PostSection/>
      <ContactSection contactText={configuration.contactText}/>
    </PageLayout>
  );
}
